export const OPEN_ASSISTANT_CHAT_EVENT = 'open-assistant-chat'

export interface OpenAssistantChatDetail {
  source: string
}

export function dispatchOpenAssistantChat(source: string) {
  window.dispatchEvent(
    new CustomEvent<OpenAssistantChatDetail>(OPEN_ASSISTANT_CHAT_EVENT, {
      detail: { source },
    })
  )
}

/**
 * Fired by the assistant chat when a brand-editing tool result lands, so the
 * Brand page (if mounted) can silently refetch the kit + guidelines and
 * reflect the agent's change live.
 */
export const BRAND_TOOL_ACTIVITY_EVENT = 'assistant-brand-tool-activity'

/** Tool result `type`s that write brand data. */
export const BRAND_TOOL_TYPES = new Set([
  'patchBrandCard',
  'setBrandTone',
  'setBrandColors',
  'captureBrandMemory',
])

/**
 * Fired by the assistant chat when a scheduling tool result lands, so the
 * Calendar page and Home week floor (if mounted) can silently refetch and
 * show the move live. Without this the receipt says "moved" while the grid
 * behind the panel still shows the old slot until a manual reload.
 */
export const SCHEDULE_TOOL_ACTIVITY_EVENT = 'assistant-schedule-tool-activity'

/** Tool result `type`s that write schedule data. */
export const SCHEDULE_TOOL_TYPES = new Set(['reschedulePost'])
